var scope_0 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4b10c8c151ff76b2b7df33c06f9a7ed9.js').default;
var scope_1 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6fbaf5450b111263fe011bbf9ec61e60.js').default;
var scope_2 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    